import React from 'react';

const StatCard = ({ label, value, sub, icon, color = 'blue' }) => {
  const colors = {
    blue: 'bg-blue-50 dark:bg-blue-900/20 border-blue-200 dark:border-blue-700 text-blue-700 dark:text-blue-400',
    green: 'bg-green-50 border-green-200 text-green-700 dark:text-green-400',
    red: 'bg-red-50 border-red-200 text-red-700 dark:text-red-400',
    purple: 'bg-purple-50 border-purple-200 text-purple-700',
    orange: 'bg-orange-50 border-orange-200 text-orange-700 dark:text-orange-400',
    gray: 'bg-gray-50 dark:bg-gray-800 border-gray-200 dark:border-gray-700 text-gray-700 dark:text-gray-300',
  };

  return (
    <div className={`${colors[color] || colors.blue} border rounded-lg p-4`}>
      <div className="flex items-center justify-between mb-1">
        <span className="text-sm font-medium opacity-80">{label}</span>
        {icon && <span className="text-lg">{icon}</span>}
      </div>
      <div className="text-2xl font-bold">{value}</div>
      {sub && <div className="text-xs opacity-70 mt-1">{sub}</div>}
    </div>
  );
};

export default StatCard;
